import { Subject } from 'rxjs'

export const UserWaypointChanged = new Subject<void>()
